var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "inputLabelArea" }, [
    _c(
      "label",
      {
        staticClass: "inputLabel",
        class: {
          required: _vm.required,
          optional: _vm.optional,
          isPc: !_vm.isSp,
          isHasLabel: !_vm.isSp && (_vm.required || _vm.optional),
          rightSpace: _vm.rightSpace,
          isPcModal: _vm.isPcModal,
          isSotsunen: _vm.isSotsunen,
        },
      },
      [_vm._t("default")],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }